import { useForm } from "react-hook-form";
import { useDataFetch } from "../../../../hooks/useDataFetch2";
import { Suspense, useMemo, useState } from "react";
import Breadcrumb from "../../../../components/ui/materialui/breadcrumb";
import { Box, Grid2, Paper } from "@mui/material";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import InputRut from "../../../../components/inputs/yup/materialui/inputRut";
import InputText from "../../../../components/inputs/yup/materialui/inputText";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import { FilterList } from "@mui/icons-material";
import Tabla from "../../../../components/ui/materialui/serverSideTable";
import TableHeader from "../../../../components/ui/materialui/tableHeader";
import { exportExcel } from "../../../../utils/exportExcel";
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import { useColumns } from "../utils/columns";
import InputSwitch from "../../../../components/inputs/yup/materialui/inputSwitch";
import { ClientesCesantesDTO, ModificarCesanteDTO } from "../models/clientesCesantes";
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import ModalCesante from "../components/modalCesante";
import { editarCesante } from "../service/serviceCesante";
import { PermissionGuard } from "../../../../components/auth/ProtectedRoute";
import { TipoFuncionalidad } from "../../../../utils/enums";



interface IProps {
    nroOperacion: string;
    rut: string;
    omd: string;
    estado: boolean;
}

function ClientesCesantes() {
    const [modalDetalle, setModalDetalle] = useState<boolean>(false)
    const [cesanteEditar, setcesanteEditar] = useState<ClientesCesantesDTO>();
    const [isEdit, setIsEdit] = useState<boolean>(false);


    const urlTabla = `siscred-api-maestros/v1/clientescesantes/listar`;

    const controlTabla = useDataFetch(
        urlTabla,
        new URLSearchParams('filters.status=Activo'),
        true,
    )
    const {
        formState: { errors },
        control,
        handleSubmit,
    } = useForm<IProps>({
        mode: 'onBlur',
        defaultValues: {
            estado: true, 
        }
    })

    const { COLUMNS } = useColumns({ controlTabla, setModalDetalle, setcesanteEditar, isEdit: setIsEdit });

    const columns = useMemo(() => COLUMNS, [controlTabla]);

    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Cobranzas', url: `/cobranzas` },
        { label: 'Clientes cesantes', active: true },
    ]

    const onSubmit = async (data: IProps) => {
        const rutLimpio = data.rut ? data.rut.replace(/\./g, '') : '';

        if (rutLimpio) {
            controlTabla.manejarCambiosFiltros('filters.rut', rutLimpio);
        } else {
            controlTabla.manejarCambiosFiltros('filters.rut', '');
        }
        if (data.nroOperacion) {
            controlTabla.manejarCambiosFiltros('filters.numeroOperacion', data.nroOperacion);
        } else {
            controlTabla.manejarCambiosFiltros('filters.numeroOperacion', '');
        }

        if (data.omd) {
            controlTabla.manejarCambiosFiltros('filters.omd', data.omd);
        } else {
            controlTabla.manejarCambiosFiltros('filters.omd', '');
        }

        controlTabla.manejarCambiosFiltros('filters.activo', data.estado ? 'SI' : 'NO');

        await controlTabla.fetchData();


    }

    return (
        <>
            <Suspense>
                <Breadcrumb items={breadcrumbItems} />
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Suspense>
                            <CustomAccordion
                                title='Filtros'
                                expandedDefault
                            >
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Grid2 container spacing={2}>

                                        <Grid2 size={2}>
                                            <InputText
                                                name="nroOperacion"
                                                control={control}
                                                label='N° Operación'
                                            />
                                        </Grid2>
                                        <Grid2 size={2}>
                                            <InputText
                                                name="omd"
                                                control={control}
                                                label='OMD'
                                            />
                                        </Grid2>
                                        <Grid2 size={2}>
                                            <InputRut
                                                name="rut"
                                                control={control}
                                                label="RUT"
                                            />
                                        </Grid2>

                                        <Grid2 size={3}>
                                            <InputSwitch
                                                name="estado"
                                                control={control}
                                                label='Activo'
                                            />
                                        </Grid2>
                                        <Grid2 size={3} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                            <PermissionGuard permissions={[TipoFuncionalidad.Cobranza_ver]}>
                                            <MButton type="submit" variant="contained" color="primary" startIcon={<FilterList />}>
                                                Filtrar
                                            </MButton>
                                            </PermissionGuard>
                                        </Grid2>
                                    </Grid2>
                                </form>
                            </CustomAccordion>
                            <Tabla
                                columns={columns}
                                control={controlTabla}
                                url={urlTabla}
                                callApi={false}
                                titulo={
                                    <TableHeader
                                        title=""
                                        control={controlTabla}
                                        button={
                                            <PermissionGuard permissions={[TipoFuncionalidad.Cobranza_adm_cesantes]}>
                                            <MButton
                                                type="button"
                                                variant="contained"
                                                onClick={() => { setModalDetalle(true); setcesanteEditar(undefined); }}
                                                startIcon={<AddTwoToneIcon />}
                                            >
                                                Nuevo
                                            </MButton>
                                            </PermissionGuard>
                                        }
                                        buttonExport={
                                            <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                                            <MButton
                                                type="button"
                                                variant="outlined"
                                                onClick={() => exportExcel(controlTabla.data, columns, "Clientes Cesantes")}
                                                startIcon={<SummarizeTwoToneIcon />}
                                            >
                                                Exportar
                                            </MButton>
                                            </PermissionGuard>
                                        }
                                    />
                                }
                            />
                        </Suspense>
                    </Paper>
                </Box>


            </Suspense>
            <ModalCesante
                show={modalDetalle}
                datosEditar={cesanteEditar}
                onHide={() => setModalDetalle(false)}
                refresh={() => controlTabla.fetchData()}
            />

        </>
    );



}
export default ClientesCesantes;
